enum StatsRowHeaderType {
  CollectorsHeader = "collectors_header",
  CreatorsHeader = "creators_header",
}

export default StatsRowHeaderType;
